/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ListAddonsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * AddonsAPIApi - axios parameter creator
 * @export
 */
export const AddonsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Method to list available add-ons filtered by cloud provider.
         * @summary List available add-ons
         * @param {AddonsAPIListAddonsProviderEnum} [provider] Cloud provider to filter add-ons by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsAPIListAddons: async (provider?: AddonsAPIListAddonsProviderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/omni-provisioner/v1beta/addons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddonsAPIApi - functional programming interface
 * @export
 */
export const AddonsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddonsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Method to list available add-ons filtered by cloud provider.
         * @summary List available add-ons
         * @param {AddonsAPIListAddonsProviderEnum} [provider] Cloud provider to filter add-ons by.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addonsAPIListAddons(provider?: AddonsAPIListAddonsProviderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAddonsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addonsAPIListAddons(provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonsAPIApi.addonsAPIListAddons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddonsAPIApi - factory interface
 * @export
 */
export const AddonsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddonsAPIApiFp(configuration)
    return {
        /**
         * Method to list available add-ons filtered by cloud provider.
         * @summary List available add-ons
         * @param {AddonsAPIApiAddonsAPIListAddonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addonsAPIListAddons(requestParameters: AddonsAPIApiAddonsAPIListAddonsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListAddonsResponse> {
            return localVarFp.addonsAPIListAddons(requestParameters.provider, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addonsAPIListAddons operation in AddonsAPIApi.
 * @export
 * @interface AddonsAPIApiAddonsAPIListAddonsRequest
 */
export interface AddonsAPIApiAddonsAPIListAddonsRequest {
    /**
     * Cloud provider to filter add-ons by.
     * @type {'CLOUD_PROVIDER_TYPE_UNSPECIFIED' | 'GCP' | 'AWS' | 'OCI' | 'NEBIUS' | 'CUSTOM'}
     * @memberof AddonsAPIApiAddonsAPIListAddons
     */
    readonly provider?: AddonsAPIListAddonsProviderEnum
}

/**
 * AddonsAPIApi - object-oriented interface
 * @export
 * @class AddonsAPIApi
 * @extends {BaseAPI}
 */
export class AddonsAPIApi extends BaseAPI {
    /**
     * Method to list available add-ons filtered by cloud provider.
     * @summary List available add-ons
     * @param {AddonsAPIApiAddonsAPIListAddonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddonsAPIApi
     */
    public addonsAPIListAddons(requestParameters: AddonsAPIApiAddonsAPIListAddonsRequest = {}, options?: RawAxiosRequestConfig) {
        return AddonsAPIApiFp(this.configuration).addonsAPIListAddons(requestParameters.provider, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AddonsAPIListAddonsProviderEnum = {
    CLOUD_PROVIDER_TYPE_UNSPECIFIED: 'CLOUD_PROVIDER_TYPE_UNSPECIFIED',
    GCP: 'GCP',
    AWS: 'AWS',
    OCI: 'OCI',
    NEBIUS: 'NEBIUS',
    CUSTOM: 'CUSTOM'
} as const;
export type AddonsAPIListAddonsProviderEnum = typeof AddonsAPIListAddonsProviderEnum[keyof typeof AddonsAPIListAddonsProviderEnum];
